import React, {FC, useState} from 'react'
import {useForm, FormProvider} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {site} from '../../../schema/site'
import {SiteModel} from '../../../model'
import {TabCentralModel} from '../../../../../models'
import {useCentral} from '../../../../../hooks/useCentral'
import ActionsContent from '../../componentes/Actions'
import ContainerWrapper from '../../componentes/Container'
import {ResizeHandle} from '../../../../hoteleria/components/Layout/Container/ResizeHandle/ResizeHandle'
import {createSite, deleteSite, updateSite} from '../../../services'
import {renderPanelContent} from '../components'
import {ShowSnackBar, getDataModified} from '../../../../../util/functions'
import {funcDelete} from '../../../util/function'
import {
  SUCCESS_MESSAGE_CREATE,
  SUCCESS_MESSAGE_UPDATE,
  ERROR_MESSAGE_SYSTEM,
} from '../../../../../util/Constants'
import {initValues} from '../../../util/values/site'
const SitePageWrapper: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useCentral()
  const [loading, setLoading] = useState(false)
  const methods = useForm<SiteModel>({
    defaultValues: initValues,
    resolver: yupResolver(site),
  })
  const {reset} = methods

  const handleDelete = async () => {
    await funcDelete(
      deleteSite,
      currentTabItem,
      setLoading,
      changeCurrentTabItem,
      currentTabItem.idToDelete ?? '',
    )
  }

  const onSubmit = async (data: SiteModel) => {
    try {
      setLoading(true)
      data = getDataModified(data)
      const isCreating = !currentTabItem.idToEdit
      const response = isCreating
        ? await createSite(data)
        : await updateSite({...data, id: currentTabItem.idToEdit})

      if (!response.data.error) {
        reset()
        const messageResponse = isCreating ? SUCCESS_MESSAGE_CREATE : SUCCESS_MESSAGE_UPDATE
        const obj: TabCentralModel = {
          ...currentTabItem,
          showPanel: false,
          content: {
            ...currentTabItem.content,
            headerPanel: 'table-site',
          },
          idToEdit: '',
          loadingTable: true,
        }
        changeCurrentTabItem(obj)
        ShowSnackBar(messageResponse)
      } else {
        ShowSnackBar(response.data.messageSystem ?? ERROR_MESSAGE_SYSTEM, 'error')
      }
    } catch (error) {
      console.error(ERROR_MESSAGE_SYSTEM, error)
      ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    } finally {
      setLoading(false)
    }
  }
  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ActionsContent
          deleteClick={handleDelete}
          loading={loading}
          textComponentBack='table-site'
          textComponentGo='form-site'
        />
        <ContainerWrapper>
          <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
            <Panel
              collapsible={true}
              order={1}
              key={`panel-central-header-${currentTabItem.id}`}
              id={`panel-central-header-${currentTabItem.id}`}
              className={'panel__box'}
            >
              {renderPanelContent(currentTabItem.content.headerPanel)}
            </Panel>
            <>
              {currentTabItem.showPanel && (
                <>
                  <ResizeHandle />
                  <Panel
                    className={'panel__box'}
                    collapsible={true}
                    defaultSize={50}
                    order={2}
                    key={`panel-central-detail-${currentTabItem.id}`}
                    id={`panel-central-detail-${currentTabItem.id}`}
                  >
                    {renderPanelContent(currentTabItem.content.detailPanel)}
                  </Panel>
                </>
              )}
            </>
          </PanelGroup>
        </ContainerWrapper>
      </form>
    </FormProvider>
  )
}

export default SitePageWrapper
